import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "chordInputModal.title",
    },
    description: {
        id: "chordInputModal.description",
    },
    close: {
        id: "general.close",
    },
    noMore: {
        id: "intervalInputModa.noMore",
    },
});

export default messages;
